import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-produccion',
  templateUrl: './produccion.component.html',
  styleUrls: ['./produccion.component.scss']
})
export class ProduccionComponent implements OnInit {

  // FECHAS
  date_desde: string = new Date().toISOString().slice(0, 10);
  date_hasta: string = new Date().toISOString().slice(0, 10);

  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.date_desde = dateStr
  };

  dateTime2: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => { this.date_hasta = dateStr; }
  };

  // Data
  produccion: any[] = [];
  total: any[] = [];

  constructor(public rest: RestService) { }

  ngOnInit() { this.GetData(); }

  GetProduccion() {
    this.rest.GetProduccion(this.date_desde,this.date_hasta).subscribe( (data) => {
      this.produccion = data['data'];
    });
  }

  GetProduccionTotal() {
    this.rest.GetProduccionTotal(this.date_desde,this.date_hasta).subscribe( (data) => {
      this.total = data['data'];
    });
  }

  GetData() {
    this.GetProduccion();
    this.GetProduccionTotal();
  }
}
